import { dew as _FullJitterBackoffDew } from "../backoff/FullJitterBackoff";
import { dew as _DefaultEventControllerDew } from "../eventcontroller/DefaultEventController";
import { dew as _NoOpDebugLoggerDew } from "../logger/NoOpDebugLogger";
import { dew as _NoOpMediaStreamBrokerDew } from "../mediastreambroker/NoOpMediaStreamBroker";
import { dew as _MeetingSessionConfigurationDew } from "../meetingsession/MeetingSessionConfiguration";
import { dew as _MeetingSessionCredentialsDew } from "../meetingsession/MeetingSessionCredentials";
import { dew as _MeetingSessionStatusDew } from "../meetingsession/MeetingSessionStatus";
import { dew as _MeetingSessionStatusCodeDew } from "../meetingsession/MeetingSessionStatusCode";
import { dew as _MeetingSessionURLsDew } from "../meetingsession/MeetingSessionURLs";
import { dew as _DefaultReconnectControllerDew } from "../reconnectcontroller/DefaultReconnectController";
import { dew as _DefaultWebSocketAdapterDew } from "../websocketadapter/DefaultWebSocketAdapter";
import { dew as _DefaultAudioVideoControllerDew } from "./DefaultAudioVideoController";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  // SPDX-License-Identifier: Apache-2.0
  var __importDefault = exports && exports.__importDefault || function (mod) {
    return mod && mod.__esModule ? mod : {
      "default": mod
    };
  };
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  const FullJitterBackoff_1 = __importDefault(_FullJitterBackoffDew());
  const DefaultEventController_1 = __importDefault(_DefaultEventControllerDew());
  const NoOpDebugLogger_1 = __importDefault(_NoOpDebugLoggerDew());
  const NoOpMediaStreamBroker_1 = __importDefault(_NoOpMediaStreamBrokerDew());
  const MeetingSessionConfiguration_1 = __importDefault(_MeetingSessionConfigurationDew());
  const MeetingSessionCredentials_1 = __importDefault(_MeetingSessionCredentialsDew());
  const MeetingSessionStatus_1 = __importDefault(_MeetingSessionStatusDew());
  const MeetingSessionStatusCode_1 = __importDefault(_MeetingSessionStatusCodeDew());
  const MeetingSessionURLs_1 = __importDefault(_MeetingSessionURLsDew());
  const DefaultReconnectController_1 = __importDefault(_DefaultReconnectControllerDew());
  const DefaultWebSocketAdapter_1 = __importDefault(_DefaultWebSocketAdapterDew());
  const DefaultAudioVideoController_1 = __importDefault(_DefaultAudioVideoControllerDew());
  class NoOpAudioVideoController extends DefaultAudioVideoController_1.default {
    constructor(configuration) {
      const emptyConfiguration = new MeetingSessionConfiguration_1.default();
      emptyConfiguration.meetingId = "";
      emptyConfiguration.externalMeetingId = "";
      emptyConfiguration.credentials = new MeetingSessionCredentials_1.default();
      emptyConfiguration.credentials.attendeeId = "";
      emptyConfiguration.credentials.joinToken = "";
      emptyConfiguration.urls = new MeetingSessionURLs_1.default();
      emptyConfiguration.urls.turnControlURL = "";
      emptyConfiguration.urls.audioHostURL = "";
      emptyConfiguration.urls.signalingURL = "wss://localhost/";
      const noOpLogger = new NoOpDebugLogger_1.default();
      super(configuration ? configuration : emptyConfiguration, noOpLogger, new DefaultWebSocketAdapter_1.default(new NoOpDebugLogger_1.default()), new NoOpMediaStreamBroker_1.default(), new DefaultReconnectController_1.default(0, new FullJitterBackoff_1.default(0, 0, 0)), new DefaultEventController_1.default(configuration ? configuration : emptyConfiguration, noOpLogger));
    }
    setAudioProfile(_audioProfile) {}
    start() {}
    stop() {}
    promoteToPrimaryMeeting(_) {
      return Promise.resolve(new MeetingSessionStatus_1.default(MeetingSessionStatusCode_1.default.OK));
    }
    demoteFromPrimaryMeeting() {}
  }
  exports.default = NoOpAudioVideoController;
  //# sourceMappingURL=NoOpAudioVideoController.js.map
  return exports;
}